import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DataTable } from '@vibrent/electryon';
import { getSurveyVersions } from './api';
import './SurveyList.scss';
import { formatCellValue, getLocalizedText } from './textUtils';

const WIDTH_SIZE_1 = '20%';
const WIDTH_SIZE_2 = '80%';

const renderValue = value => (
  <div>
    <div>{formatCellValue(value)}</div>
  </div>
);

const renderNotes = (row) => {
  const surveyJsonStr = row.json || row.latestVersionSurveyJson;
  if (!surveyJsonStr) {
    return (
      <div>
        <div>N/A</div>
      </div>
    );
  }
  try {
    const surveyJson = JSON.parse(surveyJsonStr);
    return (
      <div>
        <div>{formatCellValue(surveyJson.description)}</div>
      </div>
    );
  } catch (err) {
    return (
      <div>
        <div>N/A</div>
      </div>
    );
  }
};

const getColumn = () => {
  const standardCols = [
    {
      key: 'versionNumber',
      text: 'VERSION ID',
      isPrimaryKey: true,
      pinned: true,
      headerAlign: 'left',
      dataAlign: 'left',
      colHeaderCss: 'versions-th',
      width: WIDTH_SIZE_1,
      formatter: cell => renderValue(cell),
    },
    {
      key: 'notes',
      text: 'NOTES',
      colCss: 'file-repository-col',
      colHeaderCss: 'versions-th',
      width: WIDTH_SIZE_2,
      formatter: (cell, row) => renderNotes(row),
    },
  ];
  return standardCols;
};

function SurveyVersions(props) {
  const { surveyId } = props.match.params;
  const [versions, setVersions] = useState([]);
  const [surveyName, setSurveyName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadVersions = async () => {
    try {
      setLoading(true);
      const response = await getSurveyVersions(surveyId);
      setVersions(response.versions || []);
      setSurveyName(response.surveyName || '');
      setLoading(false);
    } catch (err) {
      setError('Failed to load survey versions');
      setLoading(false);
      console.error('Error loading versions:', err);
    }
  };

  useEffect(() => {
    loadVersions();
  }, []);

  const options = {
    noDataText: (
      <div className="no-data">
        <div className="no-data__icon">
          <i className="fas fa-badge-check" />
        </div>
        <div className="no-data__title">No versions found for this survey</div>
      </div>
    ),
    nameUnitItemTable: 'Versions Table',
  };

  if (loading) return <div>Loading versions...</div>;
  if (error) return <div className="error">{error}</div>;

  const localizedName = getLocalizedText(surveyName);
  const displaySurveyName = localizedName != null ? localizedName : surveyId;

  return (
    <div className="survey-list-container">
      <div className="titles">
        <Link to="/surveys" className="back-link">
          Survey Builder
        </Link>
        &nbsp;&gt;
        <span className="current-page"> Versions</span>
      </div>
      <div className="survey-versions-container">
        <div className="versions-table">
          <h3>{displaySurveyName}</h3>
          <React.Fragment>
            <div>
              <DataTable
                hover
                columns={getColumn()}
                options={options}
                data={versions}
              />
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
}

SurveyVersions.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      surveyId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(null, null)(SurveyVersions);
